import api from './api';
import type { StorageAssetDetail, StorageSegmentsResponse, StorageTranscriptResponse } from '@/types';

export const storageService = {
  /**
   * §6.3 GET /api/v2/storage/assets/{asset_id}
   * Full asset detail including CU summary.
   */
  getAsset: (assetId: string) =>
    api.get<StorageAssetDetail>(`/storage/assets/${assetId}`),

  /**
   * §6.4 GET /api/v2/storage/assets/{asset_id}/transcript
   * Full timestamped transcript. Returns 404 if CU hasn't completed yet.
   */
  getTranscript: (assetId: string) =>
    api.get<StorageTranscriptResponse>(`/storage/assets/${assetId}/transcript`),

  /**
   * §6.5 GET /api/v2/storage/assets/{asset_id}/segments
   * Scene segments with keyframe timestamps.
   */
  getSegments: (assetId: string) =>
    api.get<StorageSegmentsResponse>(`/storage/assets/${assetId}/segments`),
};
